<template>
  <div>
    <div v-if="error != ''" class="p-4">
      <ErrorMessage :message="error" />
    </div>
    <div v-else class="w-100">
      <div class="w-100">
        <div class="w-100 p-4 bg-white">
          <div class="row">
            <div class="col-1 align-self-center" @click="pageTo('member')">
              <div class="d-inline-grid cursor-pointer">
                <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 7.875H4.30875L10.5975 1.58625L9 0L0 9L9 18L10.5862 16.4138L4.30875 10.125H18V7.875Z" fill="#222"/>
                </svg>
              </div>
            </div>
            <div class="col-9 align-self-center">
              <p class="mb-0 body-1-2">Member detail</p>
            </div>
          </div>
        </div>
        <template v-if="is_load">
          <div class="p-4 bg-grey-ga mb-4">
            <div class="d-table mx-auto">
              <div style="width: 400px;height: 240px;padding: 20px;" class="radius-12 border-semi-grey position-relative bg-white">
                <b-skeleton width="50%" height="33px"></b-skeleton>
                <div class="position-absolute" style="right: 20px; top: 20px;">
                  <b-skeleton width="50px" height="50px"></b-skeleton>
                </div>
                <div class="d-block" style="margin-top: 40px;">
                  <b-skeleton class="mb-1" width="40%" height="18px"></b-skeleton>
                  <b-skeleton width="50%" height="24px"></b-skeleton>
                </div>
                <div class="d-block" style="margin-top: 44px;">
                  <div class="row">
                    <div class="col-6 align-self-end">
                      <b-skeleton width="100%" height="27px"></b-skeleton>
                    </div>
                    <div class="col-6 align-self-end">
                      <b-skeleton class="mb-1 ml-auto" width="25%" height="10px"></b-skeleton>
                      <b-skeleton class="mb-1 ml-auto" width="50%" height="24px"></b-skeleton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-4">
            <div class="w-100 mb-5">
              <b-skeleton class="mb-3" width="50%" height="30px"></b-skeleton>
              <div class="w-100 mb-2 no-ws" v-for="i in 3">
                <div class="w-5 d-inline-block align-middle mr-2">
                  <b-skeleton width="100%" height="20px"></b-skeleton>
                </div>
                <div class="w-70 d-inline-block align-middle">
                  <b-skeleton width="70%" height="21px"></b-skeleton>
                </div>
              </div>
            </div>
            <div class="w-100">
              <b-skeleton class="mb-3" width="50%" height="30px"></b-skeleton>
              <b-skeleton class="mb-1" width="80%" height="21px"></b-skeleton>
              <b-skeleton class="mb-1" width="60%" height="21px"></b-skeleton>
              <b-skeleton class="mb-1" width="70%" height="21px"></b-skeleton>
              <b-skeleton class="mb-1" width="50%" height="21px"></b-skeleton>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="p-4 bg-grey-ga mb-4">
            <div class="d-table mx-auto">
              <MemberCard :data="data"></MemberCard>
            </div>
          </div>
          <div class="mx-4">
            <div class="w-100 mb-5">
              <p class="heading-6-1 mb-3">Member Exclusive Benefits</p>
              <div class="w-100 mb-3 d-flex align-items-center" v-for="benefit in data.benefit">
                <img src="../../../assets/img/icon/green-checked.png" width="23" class="mr-3">
                <p class="mb-0 body-2-1 html-desc" v-html="benefit"></p>
              </div>
            </div>
            <div class="w-100">
              <p class="heading-6-1 mb-3">Terms & Conditions</p>
              <div class="html-desc body-2-2-1" v-html="data.terms_and_conditions"></div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script> 
  import {get} from '@/services/index.js'
  import {mapGetters,mapMutations} from "vuex";
  import MemberCard from '@/components/hotel/concierge/member/MemberCard'

  export default {
    components:{
      MemberCard
    },
    data() {
      return {
        is_load: true,
        error: '',
        data: {}
      }
    },  
    computed:{
      ...mapGetters(['getMerchant','isNotLogin','getCurrentUser'])
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadMemberCard()
        ])
        .catch(err=>this.error=err)
        .finally(()=>{
          setTimeout(()=>{
            this.is_load = false
          },400)
        })
      },
      loadMemberCard(){
        return new Promise((success,fail)=>{
          get("CONCIERGE","membership/user-member-card-detail",{
	          merchant_id: this.getMerchant.id
	        }).then(response=>{
	        	let res = response.data
	         	if(res.success){
              this.data = res.data
	         		success()
	         	}else{
	         		fail(res.message)
	         	}
	        })
        })
      },
      pageTo(page){
        this.$router.push(`/${this.getMerchant.code}/${page}`)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/general/membership/CardDetail.vue